import React from "react";
import Leadmagnet from "./Leadmagnet.jsx";

const LeadmagnetProtected = () => {
  return <Leadmagnet />;
};

export default LeadmagnetProtected;
